import { Client } from "colyseus.js";

export class ColyseusClientWrapper {
  constructor({ url }) {
    this.url = url;
    this.client = new Client(url);
    this.lobbyRoom = null;
    this.tableRoom = null;
  }

  async connectLobby(options) {
    if (this.lobbyRoom) {
      await this.leaveLobby();
    }

    try {
      this.lobbyRoom = await this.client.joinOrCreate("lobby", options);
      return this.lobbyRoom;
    } catch (error) {
      this.lobbyRoom = null;
      throw error;
    }
  }

  async connectTable(tableOptions) {
    if (this.tableRoom) return this.tableRoom;
    this.tableRoom = await this.client.joinOrCreate("game_table", tableOptions);
    return this.tableRoom;
  }

  async leaveLobby() {
    if (this.lobbyRoom) {
      try {
        await this.lobbyRoom.leave(true);
      } catch (err) {
        console.error("[ColyseusClient] Error during leave:", err);
      }
      this.lobbyRoom = null;
    }
  }

  leaveTable() {
    if (this.tableRoom) {
      this.tableRoom.leave();
      this.tableRoom = null;
    }
  }
}
